// source: acompanha/quotes/v1/quotes.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.quotes.v1.ArchiveQuoteRequest', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.ArchiveQuoteResponse', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.CreateQuoteRequest', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.CreateQuoteResponse', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.DeleteQuoteRequest', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.GetQuoteRequest', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.GetQuoteResponse', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.ListQuotesRequest', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.ListQuotesResponse', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.Quote', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.QuoteListItem', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.QuotePaymentOption', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.QuoteShippingOption', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.UnarchiveQuoteRequest', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.UnarchiveQuoteResponse', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.UpdateQuoteRequest', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.UpdateQuoteResponse', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.UpdateQuoteStatusRequest', null, global);
goog.exportSymbol('proto.acompanha.quotes.v1.UpdateQuoteStatusResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.QuoteShippingOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.QuoteShippingOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.QuoteShippingOption.displayName = 'proto.acompanha.quotes.v1.QuoteShippingOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.QuotePaymentOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.QuotePaymentOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.QuotePaymentOption.displayName = 'proto.acompanha.quotes.v1.QuotePaymentOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.Quote = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.quotes.v1.Quote.repeatedFields_, null);
};
goog.inherits(proto.acompanha.quotes.v1.Quote, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.Quote.displayName = 'proto.acompanha.quotes.v1.Quote';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.QuoteListItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.QuoteListItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.QuoteListItem.displayName = 'proto.acompanha.quotes.v1.QuoteListItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.ListQuotesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.ListQuotesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.ListQuotesRequest.displayName = 'proto.acompanha.quotes.v1.ListQuotesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.ListQuotesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.quotes.v1.ListQuotesResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.quotes.v1.ListQuotesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.ListQuotesResponse.displayName = 'proto.acompanha.quotes.v1.ListQuotesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.GetQuoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.GetQuoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.GetQuoteRequest.displayName = 'proto.acompanha.quotes.v1.GetQuoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.GetQuoteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.GetQuoteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.GetQuoteResponse.displayName = 'proto.acompanha.quotes.v1.GetQuoteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.CreateQuoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.quotes.v1.CreateQuoteRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.quotes.v1.CreateQuoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.CreateQuoteRequest.displayName = 'proto.acompanha.quotes.v1.CreateQuoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.CreateQuoteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.CreateQuoteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.CreateQuoteResponse.displayName = 'proto.acompanha.quotes.v1.CreateQuoteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.quotes.v1.UpdateQuoteRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.quotes.v1.UpdateQuoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.UpdateQuoteRequest.displayName = 'proto.acompanha.quotes.v1.UpdateQuoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.UpdateQuoteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.UpdateQuoteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.UpdateQuoteResponse.displayName = 'proto.acompanha.quotes.v1.UpdateQuoteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.DeleteQuoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.DeleteQuoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.DeleteQuoteRequest.displayName = 'proto.acompanha.quotes.v1.DeleteQuoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.UpdateQuoteStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.UpdateQuoteStatusRequest.displayName = 'proto.acompanha.quotes.v1.UpdateQuoteStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.UpdateQuoteStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.displayName = 'proto.acompanha.quotes.v1.UpdateQuoteStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.ArchiveQuoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.ArchiveQuoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.ArchiveQuoteRequest.displayName = 'proto.acompanha.quotes.v1.ArchiveQuoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.ArchiveQuoteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.ArchiveQuoteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.ArchiveQuoteResponse.displayName = 'proto.acompanha.quotes.v1.ArchiveQuoteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.UnarchiveQuoteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.UnarchiveQuoteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.UnarchiveQuoteRequest.displayName = 'proto.acompanha.quotes.v1.UnarchiveQuoteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.UnarchiveQuoteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.UnarchiveQuoteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.UnarchiveQuoteResponse.displayName = 'proto.acompanha.quotes.v1.UnarchiveQuoteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.displayName = 'proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.displayName = 'proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.QuoteShippingOption.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.QuoteShippingOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.QuoteShippingOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.QuoteShippingOption.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
cost: jspb.Message.getFieldWithDefault(msg, 2, 0),
deliveryDays: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.QuoteShippingOption}
 */
proto.acompanha.quotes.v1.QuoteShippingOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.QuoteShippingOption;
  return proto.acompanha.quotes.v1.QuoteShippingOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.QuoteShippingOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.QuoteShippingOption}
 */
proto.acompanha.quotes.v1.QuoteShippingOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCost(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDeliveryDays(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.QuoteShippingOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.QuoteShippingOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.QuoteShippingOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.QuoteShippingOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCost();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDeliveryDays();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.quotes.v1.QuoteShippingOption.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.QuoteShippingOption} returns this
 */
proto.acompanha.quotes.v1.QuoteShippingOption.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 cost = 2;
 * @return {number}
 */
proto.acompanha.quotes.v1.QuoteShippingOption.prototype.getCost = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.QuoteShippingOption} returns this
 */
proto.acompanha.quotes.v1.QuoteShippingOption.prototype.setCost = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 delivery_days = 3;
 * @return {number}
 */
proto.acompanha.quotes.v1.QuoteShippingOption.prototype.getDeliveryDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.QuoteShippingOption} returns this
 */
proto.acompanha.quotes.v1.QuoteShippingOption.prototype.setDeliveryDays = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.QuotePaymentOption.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.QuotePaymentOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.QuotePaymentOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.QuotePaymentOption.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
installments: jspb.Message.getFieldWithDefault(msg, 2, 0),
amount: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.QuotePaymentOption}
 */
proto.acompanha.quotes.v1.QuotePaymentOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.QuotePaymentOption;
  return proto.acompanha.quotes.v1.QuotePaymentOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.QuotePaymentOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.QuotePaymentOption}
 */
proto.acompanha.quotes.v1.QuotePaymentOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInstallments(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.QuotePaymentOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.QuotePaymentOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.QuotePaymentOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.QuotePaymentOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInstallments();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.quotes.v1.QuotePaymentOption.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.QuotePaymentOption} returns this
 */
proto.acompanha.quotes.v1.QuotePaymentOption.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 installments = 2;
 * @return {number}
 */
proto.acompanha.quotes.v1.QuotePaymentOption.prototype.getInstallments = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.QuotePaymentOption} returns this
 */
proto.acompanha.quotes.v1.QuotePaymentOption.prototype.setInstallments = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 amount = 3;
 * @return {number}
 */
proto.acompanha.quotes.v1.QuotePaymentOption.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.QuotePaymentOption} returns this
 */
proto.acompanha.quotes.v1.QuotePaymentOption.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.quotes.v1.Quote.repeatedFields_ = [8,13,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.Quote.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.Quote.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.Quote} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.Quote.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
customerUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
customerName: jspb.Message.getFieldWithDefault(msg, 3, ""),
customerPhone: jspb.Message.getFieldWithDefault(msg, 4, ""),
customerEmail: jspb.Message.getFieldWithDefault(msg, 5, ""),
customerCategory: jspb.Message.getFieldWithDefault(msg, 6, ""),
status: jspb.Message.getFieldWithDefault(msg, 7, ""),
productsList: jspb.Message.toObjectList(msg.getProductsList(),
    acompanha_common_v1_common_pb.CheckoutProduct.toObject, includeInstance),
amount: jspb.Message.getFieldWithDefault(msg, 9, 0),
discount: jspb.Message.getFieldWithDefault(msg, 10, 0),
productionDays: jspb.Message.getFieldWithDefault(msg, 11, 0),
validUntil: jspb.Message.getFieldWithDefault(msg, 12, ""),
shippingOptionsList: jspb.Message.toObjectList(msg.getShippingOptionsList(),
    proto.acompanha.quotes.v1.QuoteShippingOption.toObject, includeInstance),
paymentOptionsList: jspb.Message.toObjectList(msg.getPaymentOptionsList(),
    proto.acompanha.quotes.v1.QuotePaymentOption.toObject, includeInstance),
observations: jspb.Message.getFieldWithDefault(msg, 15, ""),
checkoutUuid: jspb.Message.getFieldWithDefault(msg, 16, ""),
quotaCountedAt: (f = msg.getQuotaCountedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
archivedAt: (f = msg.getArchivedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
discountReason: jspb.Message.getFieldWithDefault(msg, 21, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.Quote}
 */
proto.acompanha.quotes.v1.Quote.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.Quote;
  return proto.acompanha.quotes.v1.Quote.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.Quote} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.Quote}
 */
proto.acompanha.quotes.v1.Quote.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerPhone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerEmail(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerCategory(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 8:
      var value = new acompanha_common_v1_common_pb.CheckoutProduct;
      reader.readMessage(value,acompanha_common_v1_common_pb.CheckoutProduct.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiscount(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProductionDays(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidUntil(value);
      break;
    case 13:
      var value = new proto.acompanha.quotes.v1.QuoteShippingOption;
      reader.readMessage(value,proto.acompanha.quotes.v1.QuoteShippingOption.deserializeBinaryFromReader);
      msg.addShippingOptions(value);
      break;
    case 14:
      var value = new proto.acompanha.quotes.v1.QuotePaymentOption;
      reader.readMessage(value,proto.acompanha.quotes.v1.QuotePaymentOption.deserializeBinaryFromReader);
      msg.addPaymentOptions(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setObservations(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheckoutUuid(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setQuotaCountedAt(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setArchivedAt(value);
      break;
    case 19:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 20:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscountReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.Quote.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.Quote.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.Quote} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.Quote.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomerUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCustomerName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCustomerPhone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCustomerEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCustomerCategory();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      acompanha_common_v1_common_pb.CheckoutProduct.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getDiscount();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getProductionDays();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getValidUntil();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getShippingOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.acompanha.quotes.v1.QuoteShippingOption.serializeBinaryToWriter
    );
  }
  f = message.getPaymentOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.acompanha.quotes.v1.QuotePaymentOption.serializeBinaryToWriter
    );
  }
  f = message.getObservations();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getCheckoutUuid();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getQuotaCountedAt();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getArchivedAt();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDiscountReason();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.quotes.v1.Quote.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string customer_uuid = 2;
 * @return {string}
 */
proto.acompanha.quotes.v1.Quote.prototype.getCustomerUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.setCustomerUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string customer_name = 3;
 * @return {string}
 */
proto.acompanha.quotes.v1.Quote.prototype.getCustomerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.setCustomerName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string customer_phone = 4;
 * @return {string}
 */
proto.acompanha.quotes.v1.Quote.prototype.getCustomerPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.setCustomerPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string customer_email = 5;
 * @return {string}
 */
proto.acompanha.quotes.v1.Quote.prototype.getCustomerEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.setCustomerEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string customer_category = 6;
 * @return {string}
 */
proto.acompanha.quotes.v1.Quote.prototype.getCustomerCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.setCustomerCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.acompanha.quotes.v1.Quote.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated acompanha.common.v1.CheckoutProduct products = 8;
 * @return {!Array<!proto.acompanha.common.v1.CheckoutProduct>}
 */
proto.acompanha.quotes.v1.Quote.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.CheckoutProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.CheckoutProduct, 8));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.CheckoutProduct>} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
*/
proto.acompanha.quotes.v1.Quote.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.acompanha.common.v1.CheckoutProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.CheckoutProduct}
 */
proto.acompanha.quotes.v1.Quote.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.acompanha.common.v1.CheckoutProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * optional int64 amount = 9;
 * @return {number}
 */
proto.acompanha.quotes.v1.Quote.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 discount = 10;
 * @return {number}
 */
proto.acompanha.quotes.v1.Quote.prototype.getDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.setDiscount = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 production_days = 11;
 * @return {number}
 */
proto.acompanha.quotes.v1.Quote.prototype.getProductionDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.setProductionDays = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string valid_until = 12;
 * @return {string}
 */
proto.acompanha.quotes.v1.Quote.prototype.getValidUntil = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.setValidUntil = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated QuoteShippingOption shipping_options = 13;
 * @return {!Array<!proto.acompanha.quotes.v1.QuoteShippingOption>}
 */
proto.acompanha.quotes.v1.Quote.prototype.getShippingOptionsList = function() {
  return /** @type{!Array<!proto.acompanha.quotes.v1.QuoteShippingOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.quotes.v1.QuoteShippingOption, 13));
};


/**
 * @param {!Array<!proto.acompanha.quotes.v1.QuoteShippingOption>} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
*/
proto.acompanha.quotes.v1.Quote.prototype.setShippingOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.acompanha.quotes.v1.QuoteShippingOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.quotes.v1.QuoteShippingOption}
 */
proto.acompanha.quotes.v1.Quote.prototype.addShippingOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.acompanha.quotes.v1.QuoteShippingOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.clearShippingOptionsList = function() {
  return this.setShippingOptionsList([]);
};


/**
 * repeated QuotePaymentOption payment_options = 14;
 * @return {!Array<!proto.acompanha.quotes.v1.QuotePaymentOption>}
 */
proto.acompanha.quotes.v1.Quote.prototype.getPaymentOptionsList = function() {
  return /** @type{!Array<!proto.acompanha.quotes.v1.QuotePaymentOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.quotes.v1.QuotePaymentOption, 14));
};


/**
 * @param {!Array<!proto.acompanha.quotes.v1.QuotePaymentOption>} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
*/
proto.acompanha.quotes.v1.Quote.prototype.setPaymentOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.acompanha.quotes.v1.QuotePaymentOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.quotes.v1.QuotePaymentOption}
 */
proto.acompanha.quotes.v1.Quote.prototype.addPaymentOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.acompanha.quotes.v1.QuotePaymentOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.clearPaymentOptionsList = function() {
  return this.setPaymentOptionsList([]);
};


/**
 * optional string observations = 15;
 * @return {string}
 */
proto.acompanha.quotes.v1.Quote.prototype.getObservations = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.setObservations = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string checkout_uuid = 16;
 * @return {string}
 */
proto.acompanha.quotes.v1.Quote.prototype.getCheckoutUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.setCheckoutUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional google.protobuf.Timestamp quota_counted_at = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.quotes.v1.Quote.prototype.getQuotaCountedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
*/
proto.acompanha.quotes.v1.Quote.prototype.setQuotaCountedAt = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.clearQuotaCountedAt = function() {
  return this.setQuotaCountedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.Quote.prototype.hasQuotaCountedAt = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.Timestamp archived_at = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.quotes.v1.Quote.prototype.getArchivedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
*/
proto.acompanha.quotes.v1.Quote.prototype.setArchivedAt = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.clearArchivedAt = function() {
  return this.setArchivedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.Quote.prototype.hasArchivedAt = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 19;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.quotes.v1.Quote.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 19));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
*/
proto.acompanha.quotes.v1.Quote.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.Quote.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 20;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.quotes.v1.Quote.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 20));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
*/
proto.acompanha.quotes.v1.Quote.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.Quote.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional string discount_reason = 21;
 * @return {string}
 */
proto.acompanha.quotes.v1.Quote.prototype.getDiscountReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.Quote} returns this
 */
proto.acompanha.quotes.v1.Quote.prototype.setDiscountReason = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.QuoteListItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.QuoteListItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.QuoteListItem.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
customerName: jspb.Message.getFieldWithDefault(msg, 2, ""),
customerPhone: jspb.Message.getFieldWithDefault(msg, 3, ""),
customerCategory: jspb.Message.getFieldWithDefault(msg, 4, ""),
status: jspb.Message.getFieldWithDefault(msg, 5, ""),
amount: jspb.Message.getFieldWithDefault(msg, 6, 0),
validUntil: jspb.Message.getFieldWithDefault(msg, 7, ""),
productionDays: jspb.Message.getFieldWithDefault(msg, 8, 0),
checkoutUuid: jspb.Message.getFieldWithDefault(msg, 9, ""),
archivedAt: (f = msg.getArchivedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.QuoteListItem}
 */
proto.acompanha.quotes.v1.QuoteListItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.QuoteListItem;
  return proto.acompanha.quotes.v1.QuoteListItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.QuoteListItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.QuoteListItem}
 */
proto.acompanha.quotes.v1.QuoteListItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerPhone(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerCategory(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidUntil(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProductionDays(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheckoutUuid(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setArchivedAt(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.QuoteListItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.QuoteListItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.QuoteListItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomerName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCustomerPhone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCustomerCategory();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getValidUntil();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getProductionDays();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getCheckoutUuid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getArchivedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.QuoteListItem} returns this
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string customer_name = 2;
 * @return {string}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.getCustomerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.QuoteListItem} returns this
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.setCustomerName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string customer_phone = 3;
 * @return {string}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.getCustomerPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.QuoteListItem} returns this
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.setCustomerPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string customer_category = 4;
 * @return {string}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.getCustomerCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.QuoteListItem} returns this
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.setCustomerCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.QuoteListItem} returns this
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 amount = 6;
 * @return {number}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.QuoteListItem} returns this
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string valid_until = 7;
 * @return {string}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.getValidUntil = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.QuoteListItem} returns this
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.setValidUntil = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 production_days = 8;
 * @return {number}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.getProductionDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.QuoteListItem} returns this
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.setProductionDays = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string checkout_uuid = 9;
 * @return {string}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.getCheckoutUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.QuoteListItem} returns this
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.setCheckoutUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional google.protobuf.Timestamp archived_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.getArchivedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.quotes.v1.QuoteListItem} returns this
*/
proto.acompanha.quotes.v1.QuoteListItem.prototype.setArchivedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.QuoteListItem} returns this
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.clearArchivedAt = function() {
  return this.setArchivedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.hasArchivedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.quotes.v1.QuoteListItem} returns this
*/
proto.acompanha.quotes.v1.QuoteListItem.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.QuoteListItem} returns this
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.QuoteListItem.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.ListQuotesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.ListQuotesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.ListQuotesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.ListQuotesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 2, ""),
archived: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.ListQuotesRequest}
 */
proto.acompanha.quotes.v1.ListQuotesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.ListQuotesRequest;
  return proto.acompanha.quotes.v1.ListQuotesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.ListQuotesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.ListQuotesRequest}
 */
proto.acompanha.quotes.v1.ListQuotesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArchived(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.ListQuotesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.ListQuotesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.ListQuotesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.ListQuotesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getArchived();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.quotes.v1.ListQuotesRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.quotes.v1.ListQuotesRequest} returns this
*/
proto.acompanha.quotes.v1.ListQuotesRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.ListQuotesRequest} returns this
 */
proto.acompanha.quotes.v1.ListQuotesRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.ListQuotesRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.acompanha.quotes.v1.ListQuotesRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.ListQuotesRequest} returns this
 */
proto.acompanha.quotes.v1.ListQuotesRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool archived = 3;
 * @return {boolean}
 */
proto.acompanha.quotes.v1.ListQuotesRequest.prototype.getArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.quotes.v1.ListQuotesRequest} returns this
 */
proto.acompanha.quotes.v1.ListQuotesRequest.prototype.setArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.quotes.v1.ListQuotesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.ListQuotesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.ListQuotesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.ListQuotesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.ListQuotesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
quotesList: jspb.Message.toObjectList(msg.getQuotesList(),
    proto.acompanha.quotes.v1.QuoteListItem.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.ListQuotesResponse}
 */
proto.acompanha.quotes.v1.ListQuotesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.ListQuotesResponse;
  return proto.acompanha.quotes.v1.ListQuotesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.ListQuotesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.ListQuotesResponse}
 */
proto.acompanha.quotes.v1.ListQuotesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.quotes.v1.QuoteListItem;
      reader.readMessage(value,proto.acompanha.quotes.v1.QuoteListItem.deserializeBinaryFromReader);
      msg.addQuotes(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.ListQuotesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.ListQuotesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.ListQuotesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.ListQuotesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuotesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.quotes.v1.QuoteListItem.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
};


/**
 * repeated QuoteListItem quotes = 1;
 * @return {!Array<!proto.acompanha.quotes.v1.QuoteListItem>}
 */
proto.acompanha.quotes.v1.ListQuotesResponse.prototype.getQuotesList = function() {
  return /** @type{!Array<!proto.acompanha.quotes.v1.QuoteListItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.quotes.v1.QuoteListItem, 1));
};


/**
 * @param {!Array<!proto.acompanha.quotes.v1.QuoteListItem>} value
 * @return {!proto.acompanha.quotes.v1.ListQuotesResponse} returns this
*/
proto.acompanha.quotes.v1.ListQuotesResponse.prototype.setQuotesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.quotes.v1.QuoteListItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.quotes.v1.QuoteListItem}
 */
proto.acompanha.quotes.v1.ListQuotesResponse.prototype.addQuotes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.quotes.v1.QuoteListItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.quotes.v1.ListQuotesResponse} returns this
 */
proto.acompanha.quotes.v1.ListQuotesResponse.prototype.clearQuotesList = function() {
  return this.setQuotesList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 2;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.quotes.v1.ListQuotesResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.quotes.v1.ListQuotesResponse} returns this
*/
proto.acompanha.quotes.v1.ListQuotesResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.ListQuotesResponse} returns this
 */
proto.acompanha.quotes.v1.ListQuotesResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.ListQuotesResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.GetQuoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.GetQuoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.GetQuoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.GetQuoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.GetQuoteRequest}
 */
proto.acompanha.quotes.v1.GetQuoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.GetQuoteRequest;
  return proto.acompanha.quotes.v1.GetQuoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.GetQuoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.GetQuoteRequest}
 */
proto.acompanha.quotes.v1.GetQuoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.GetQuoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.GetQuoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.GetQuoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.GetQuoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.quotes.v1.GetQuoteRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.GetQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.GetQuoteRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.GetQuoteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.GetQuoteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.GetQuoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.GetQuoteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.quotes.v1.Quote.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.GetQuoteResponse}
 */
proto.acompanha.quotes.v1.GetQuoteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.GetQuoteResponse;
  return proto.acompanha.quotes.v1.GetQuoteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.GetQuoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.GetQuoteResponse}
 */
proto.acompanha.quotes.v1.GetQuoteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.quotes.v1.Quote;
      reader.readMessage(value,proto.acompanha.quotes.v1.Quote.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.GetQuoteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.GetQuoteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.GetQuoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.GetQuoteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.quotes.v1.Quote.serializeBinaryToWriter
    );
  }
};


/**
 * optional Quote data = 1;
 * @return {?proto.acompanha.quotes.v1.Quote}
 */
proto.acompanha.quotes.v1.GetQuoteResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.quotes.v1.Quote} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.quotes.v1.Quote, 1));
};


/**
 * @param {?proto.acompanha.quotes.v1.Quote|undefined} value
 * @return {!proto.acompanha.quotes.v1.GetQuoteResponse} returns this
*/
proto.acompanha.quotes.v1.GetQuoteResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.GetQuoteResponse} returns this
 */
proto.acompanha.quotes.v1.GetQuoteResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.GetQuoteResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.repeatedFields_ = [2,7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.CreateQuoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.CreateQuoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
customer: (f = msg.getCustomer()) && acompanha_common_v1_common_pb.CustomerRef.toObject(includeInstance, f),
productsList: jspb.Message.toObjectList(msg.getProductsList(),
    acompanha_common_v1_common_pb.CheckoutProduct.toObject, includeInstance),
amount: jspb.Message.getFieldWithDefault(msg, 3, 0),
discount: jspb.Message.getFieldWithDefault(msg, 4, 0),
productionDays: jspb.Message.getFieldWithDefault(msg, 5, 0),
validUntil: jspb.Message.getFieldWithDefault(msg, 6, ""),
shippingOptionsList: jspb.Message.toObjectList(msg.getShippingOptionsList(),
    proto.acompanha.quotes.v1.QuoteShippingOption.toObject, includeInstance),
paymentOptionsList: jspb.Message.toObjectList(msg.getPaymentOptionsList(),
    proto.acompanha.quotes.v1.QuotePaymentOption.toObject, includeInstance),
observations: jspb.Message.getFieldWithDefault(msg, 9, ""),
status: jspb.Message.getFieldWithDefault(msg, 10, ""),
discountReason: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.CreateQuoteRequest;
  return proto.acompanha.quotes.v1.CreateQuoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.CreateQuoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.CustomerRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.CustomerRef.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.CheckoutProduct;
      reader.readMessage(value,acompanha_common_v1_common_pb.CheckoutProduct.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiscount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProductionDays(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidUntil(value);
      break;
    case 7:
      var value = new proto.acompanha.quotes.v1.QuoteShippingOption;
      reader.readMessage(value,proto.acompanha.quotes.v1.QuoteShippingOption.deserializeBinaryFromReader);
      msg.addShippingOptions(value);
      break;
    case 8:
      var value = new proto.acompanha.quotes.v1.QuotePaymentOption;
      reader.readMessage(value,proto.acompanha.quotes.v1.QuotePaymentOption.deserializeBinaryFromReader);
      msg.addPaymentOptions(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setObservations(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscountReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.CreateQuoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.CreateQuoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.CustomerRef.serializeBinaryToWriter
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      acompanha_common_v1_common_pb.CheckoutProduct.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getDiscount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getProductionDays();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getValidUntil();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getShippingOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.acompanha.quotes.v1.QuoteShippingOption.serializeBinaryToWriter
    );
  }
  f = message.getPaymentOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.acompanha.quotes.v1.QuotePaymentOption.serializeBinaryToWriter
    );
  }
  f = message.getObservations();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDiscountReason();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional acompanha.common.v1.CustomerRef customer = 1;
 * @return {?proto.acompanha.common.v1.CustomerRef}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.getCustomer = function() {
  return /** @type{?proto.acompanha.common.v1.CustomerRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.CustomerRef, 1));
};


/**
 * @param {?proto.acompanha.common.v1.CustomerRef|undefined} value
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
*/
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated acompanha.common.v1.CheckoutProduct products = 2;
 * @return {!Array<!proto.acompanha.common.v1.CheckoutProduct>}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.CheckoutProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.CheckoutProduct, 2));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.CheckoutProduct>} value
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
*/
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.acompanha.common.v1.CheckoutProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.CheckoutProduct}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.acompanha.common.v1.CheckoutProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * optional int64 amount = 3;
 * @return {number}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 discount = 4;
 * @return {number}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.getDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.setDiscount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 production_days = 5;
 * @return {number}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.getProductionDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.setProductionDays = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string valid_until = 6;
 * @return {string}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.getValidUntil = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.setValidUntil = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated QuoteShippingOption shipping_options = 7;
 * @return {!Array<!proto.acompanha.quotes.v1.QuoteShippingOption>}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.getShippingOptionsList = function() {
  return /** @type{!Array<!proto.acompanha.quotes.v1.QuoteShippingOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.quotes.v1.QuoteShippingOption, 7));
};


/**
 * @param {!Array<!proto.acompanha.quotes.v1.QuoteShippingOption>} value
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
*/
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.setShippingOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.acompanha.quotes.v1.QuoteShippingOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.quotes.v1.QuoteShippingOption}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.addShippingOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.acompanha.quotes.v1.QuoteShippingOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.clearShippingOptionsList = function() {
  return this.setShippingOptionsList([]);
};


/**
 * repeated QuotePaymentOption payment_options = 8;
 * @return {!Array<!proto.acompanha.quotes.v1.QuotePaymentOption>}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.getPaymentOptionsList = function() {
  return /** @type{!Array<!proto.acompanha.quotes.v1.QuotePaymentOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.quotes.v1.QuotePaymentOption, 8));
};


/**
 * @param {!Array<!proto.acompanha.quotes.v1.QuotePaymentOption>} value
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
*/
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.setPaymentOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.acompanha.quotes.v1.QuotePaymentOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.quotes.v1.QuotePaymentOption}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.addPaymentOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.acompanha.quotes.v1.QuotePaymentOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.clearPaymentOptionsList = function() {
  return this.setPaymentOptionsList([]);
};


/**
 * optional string observations = 9;
 * @return {string}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.getObservations = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.setObservations = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string status = 10;
 * @return {string}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string discount_reason = 11;
 * @return {string}
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.getDiscountReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.CreateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.CreateQuoteRequest.prototype.setDiscountReason = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.CreateQuoteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.CreateQuoteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.CreateQuoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.CreateQuoteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.quotes.v1.Quote.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.CreateQuoteResponse}
 */
proto.acompanha.quotes.v1.CreateQuoteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.CreateQuoteResponse;
  return proto.acompanha.quotes.v1.CreateQuoteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.CreateQuoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.CreateQuoteResponse}
 */
proto.acompanha.quotes.v1.CreateQuoteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.quotes.v1.Quote;
      reader.readMessage(value,proto.acompanha.quotes.v1.Quote.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.CreateQuoteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.CreateQuoteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.CreateQuoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.CreateQuoteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.quotes.v1.Quote.serializeBinaryToWriter
    );
  }
};


/**
 * optional Quote data = 1;
 * @return {?proto.acompanha.quotes.v1.Quote}
 */
proto.acompanha.quotes.v1.CreateQuoteResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.quotes.v1.Quote} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.quotes.v1.Quote, 1));
};


/**
 * @param {?proto.acompanha.quotes.v1.Quote|undefined} value
 * @return {!proto.acompanha.quotes.v1.CreateQuoteResponse} returns this
*/
proto.acompanha.quotes.v1.CreateQuoteResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.CreateQuoteResponse} returns this
 */
proto.acompanha.quotes.v1.CreateQuoteResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.CreateQuoteResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.repeatedFields_ = [3,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.UpdateQuoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
customer: (f = msg.getCustomer()) && acompanha_common_v1_common_pb.CustomerRef.toObject(includeInstance, f),
productsList: jspb.Message.toObjectList(msg.getProductsList(),
    acompanha_common_v1_common_pb.CheckoutProduct.toObject, includeInstance),
amount: jspb.Message.getFieldWithDefault(msg, 4, 0),
discount: jspb.Message.getFieldWithDefault(msg, 5, 0),
productionDays: jspb.Message.getFieldWithDefault(msg, 6, 0),
validUntil: jspb.Message.getFieldWithDefault(msg, 7, ""),
shippingOptionsList: jspb.Message.toObjectList(msg.getShippingOptionsList(),
    proto.acompanha.quotes.v1.QuoteShippingOption.toObject, includeInstance),
paymentOptionsList: jspb.Message.toObjectList(msg.getPaymentOptionsList(),
    proto.acompanha.quotes.v1.QuotePaymentOption.toObject, includeInstance),
observations: jspb.Message.getFieldWithDefault(msg, 10, ""),
discountReason: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.UpdateQuoteRequest;
  return proto.acompanha.quotes.v1.UpdateQuoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.CustomerRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.CustomerRef.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    case 3:
      var value = new acompanha_common_v1_common_pb.CheckoutProduct;
      reader.readMessage(value,acompanha_common_v1_common_pb.CheckoutProduct.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiscount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProductionDays(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidUntil(value);
      break;
    case 8:
      var value = new proto.acompanha.quotes.v1.QuoteShippingOption;
      reader.readMessage(value,proto.acompanha.quotes.v1.QuoteShippingOption.deserializeBinaryFromReader);
      msg.addShippingOptions(value);
      break;
    case 9:
      var value = new proto.acompanha.quotes.v1.QuotePaymentOption;
      reader.readMessage(value,proto.acompanha.quotes.v1.QuotePaymentOption.deserializeBinaryFromReader);
      msg.addPaymentOptions(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setObservations(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscountReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.UpdateQuoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.CustomerRef.serializeBinaryToWriter
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      acompanha_common_v1_common_pb.CheckoutProduct.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getDiscount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getProductionDays();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getValidUntil();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getShippingOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.acompanha.quotes.v1.QuoteShippingOption.serializeBinaryToWriter
    );
  }
  f = message.getPaymentOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.acompanha.quotes.v1.QuotePaymentOption.serializeBinaryToWriter
    );
  }
  f = message.getObservations();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDiscountReason();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional acompanha.common.v1.CustomerRef customer = 2;
 * @return {?proto.acompanha.common.v1.CustomerRef}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.getCustomer = function() {
  return /** @type{?proto.acompanha.common.v1.CustomerRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.CustomerRef, 2));
};


/**
 * @param {?proto.acompanha.common.v1.CustomerRef|undefined} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
*/
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated acompanha.common.v1.CheckoutProduct products = 3;
 * @return {!Array<!proto.acompanha.common.v1.CheckoutProduct>}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.acompanha.common.v1.CheckoutProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, acompanha_common_v1_common_pb.CheckoutProduct, 3));
};


/**
 * @param {!Array<!proto.acompanha.common.v1.CheckoutProduct>} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
*/
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.acompanha.common.v1.CheckoutProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.common.v1.CheckoutProduct}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.acompanha.common.v1.CheckoutProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * optional int64 amount = 4;
 * @return {number}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 discount = 5;
 * @return {number}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.getDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.setDiscount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 production_days = 6;
 * @return {number}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.getProductionDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.setProductionDays = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string valid_until = 7;
 * @return {string}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.getValidUntil = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.setValidUntil = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated QuoteShippingOption shipping_options = 8;
 * @return {!Array<!proto.acompanha.quotes.v1.QuoteShippingOption>}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.getShippingOptionsList = function() {
  return /** @type{!Array<!proto.acompanha.quotes.v1.QuoteShippingOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.quotes.v1.QuoteShippingOption, 8));
};


/**
 * @param {!Array<!proto.acompanha.quotes.v1.QuoteShippingOption>} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
*/
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.setShippingOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.acompanha.quotes.v1.QuoteShippingOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.quotes.v1.QuoteShippingOption}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.addShippingOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.acompanha.quotes.v1.QuoteShippingOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.clearShippingOptionsList = function() {
  return this.setShippingOptionsList([]);
};


/**
 * repeated QuotePaymentOption payment_options = 9;
 * @return {!Array<!proto.acompanha.quotes.v1.QuotePaymentOption>}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.getPaymentOptionsList = function() {
  return /** @type{!Array<!proto.acompanha.quotes.v1.QuotePaymentOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.quotes.v1.QuotePaymentOption, 9));
};


/**
 * @param {!Array<!proto.acompanha.quotes.v1.QuotePaymentOption>} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
*/
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.setPaymentOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.acompanha.quotes.v1.QuotePaymentOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.quotes.v1.QuotePaymentOption}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.addPaymentOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.acompanha.quotes.v1.QuotePaymentOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.clearPaymentOptionsList = function() {
  return this.setPaymentOptionsList([]);
};


/**
 * optional string observations = 10;
 * @return {string}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.getObservations = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.setObservations = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string discount_reason = 11;
 * @return {string}
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.getDiscountReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteRequest.prototype.setDiscountReason = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.UpdateQuoteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.UpdateQuoteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.UpdateQuoteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.quotes.v1.Quote.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteResponse}
 */
proto.acompanha.quotes.v1.UpdateQuoteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.UpdateQuoteResponse;
  return proto.acompanha.quotes.v1.UpdateQuoteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteResponse}
 */
proto.acompanha.quotes.v1.UpdateQuoteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.quotes.v1.Quote;
      reader.readMessage(value,proto.acompanha.quotes.v1.Quote.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.UpdateQuoteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.UpdateQuoteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.UpdateQuoteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.quotes.v1.Quote.serializeBinaryToWriter
    );
  }
};


/**
 * optional Quote data = 1;
 * @return {?proto.acompanha.quotes.v1.Quote}
 */
proto.acompanha.quotes.v1.UpdateQuoteResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.quotes.v1.Quote} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.quotes.v1.Quote, 1));
};


/**
 * @param {?proto.acompanha.quotes.v1.Quote|undefined} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteResponse} returns this
*/
proto.acompanha.quotes.v1.UpdateQuoteResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteResponse} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.UpdateQuoteResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.DeleteQuoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.DeleteQuoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.DeleteQuoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.DeleteQuoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.DeleteQuoteRequest}
 */
proto.acompanha.quotes.v1.DeleteQuoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.DeleteQuoteRequest;
  return proto.acompanha.quotes.v1.DeleteQuoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.DeleteQuoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.DeleteQuoteRequest}
 */
proto.acompanha.quotes.v1.DeleteQuoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.DeleteQuoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.DeleteQuoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.DeleteQuoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.DeleteQuoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.quotes.v1.DeleteQuoteRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.DeleteQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.DeleteQuoteRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.UpdateQuoteStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteStatusRequest}
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.UpdateQuoteStatusRequest;
  return proto.acompanha.quotes.v1.UpdateQuoteStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteStatusRequest}
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.UpdateQuoteStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteStatusRequest} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteStatusRequest} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.quotes.v1.Quote.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteStatusResponse}
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.UpdateQuoteStatusResponse;
  return proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteStatusResponse}
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.quotes.v1.Quote;
      reader.readMessage(value,proto.acompanha.quotes.v1.Quote.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.quotes.v1.Quote.serializeBinaryToWriter
    );
  }
};


/**
 * optional Quote data = 1;
 * @return {?proto.acompanha.quotes.v1.Quote}
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.quotes.v1.Quote} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.quotes.v1.Quote, 1));
};


/**
 * @param {?proto.acompanha.quotes.v1.Quote|undefined} value
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteStatusResponse} returns this
*/
proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.UpdateQuoteStatusResponse} returns this
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.ArchiveQuoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.ArchiveQuoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.ArchiveQuoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.ArchiveQuoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.ArchiveQuoteRequest}
 */
proto.acompanha.quotes.v1.ArchiveQuoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.ArchiveQuoteRequest;
  return proto.acompanha.quotes.v1.ArchiveQuoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.ArchiveQuoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.ArchiveQuoteRequest}
 */
proto.acompanha.quotes.v1.ArchiveQuoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.ArchiveQuoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.ArchiveQuoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.ArchiveQuoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.ArchiveQuoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.quotes.v1.ArchiveQuoteRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.ArchiveQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.ArchiveQuoteRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.ArchiveQuoteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.ArchiveQuoteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.ArchiveQuoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.ArchiveQuoteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.quotes.v1.Quote.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.ArchiveQuoteResponse}
 */
proto.acompanha.quotes.v1.ArchiveQuoteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.ArchiveQuoteResponse;
  return proto.acompanha.quotes.v1.ArchiveQuoteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.ArchiveQuoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.ArchiveQuoteResponse}
 */
proto.acompanha.quotes.v1.ArchiveQuoteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.quotes.v1.Quote;
      reader.readMessage(value,proto.acompanha.quotes.v1.Quote.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.ArchiveQuoteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.ArchiveQuoteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.ArchiveQuoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.ArchiveQuoteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.quotes.v1.Quote.serializeBinaryToWriter
    );
  }
};


/**
 * optional Quote data = 1;
 * @return {?proto.acompanha.quotes.v1.Quote}
 */
proto.acompanha.quotes.v1.ArchiveQuoteResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.quotes.v1.Quote} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.quotes.v1.Quote, 1));
};


/**
 * @param {?proto.acompanha.quotes.v1.Quote|undefined} value
 * @return {!proto.acompanha.quotes.v1.ArchiveQuoteResponse} returns this
*/
proto.acompanha.quotes.v1.ArchiveQuoteResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.ArchiveQuoteResponse} returns this
 */
proto.acompanha.quotes.v1.ArchiveQuoteResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.ArchiveQuoteResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.UnarchiveQuoteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.UnarchiveQuoteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.UnarchiveQuoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.UnarchiveQuoteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.UnarchiveQuoteRequest}
 */
proto.acompanha.quotes.v1.UnarchiveQuoteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.UnarchiveQuoteRequest;
  return proto.acompanha.quotes.v1.UnarchiveQuoteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.UnarchiveQuoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.UnarchiveQuoteRequest}
 */
proto.acompanha.quotes.v1.UnarchiveQuoteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.UnarchiveQuoteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.UnarchiveQuoteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.UnarchiveQuoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.UnarchiveQuoteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.quotes.v1.UnarchiveQuoteRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.UnarchiveQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.UnarchiveQuoteRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.acompanha.quotes.v1.UnarchiveQuoteRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.UnarchiveQuoteRequest} returns this
 */
proto.acompanha.quotes.v1.UnarchiveQuoteRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.UnarchiveQuoteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.UnarchiveQuoteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.UnarchiveQuoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.UnarchiveQuoteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.quotes.v1.Quote.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.UnarchiveQuoteResponse}
 */
proto.acompanha.quotes.v1.UnarchiveQuoteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.UnarchiveQuoteResponse;
  return proto.acompanha.quotes.v1.UnarchiveQuoteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.UnarchiveQuoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.UnarchiveQuoteResponse}
 */
proto.acompanha.quotes.v1.UnarchiveQuoteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.quotes.v1.Quote;
      reader.readMessage(value,proto.acompanha.quotes.v1.Quote.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.UnarchiveQuoteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.UnarchiveQuoteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.UnarchiveQuoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.UnarchiveQuoteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.quotes.v1.Quote.serializeBinaryToWriter
    );
  }
};


/**
 * optional Quote data = 1;
 * @return {?proto.acompanha.quotes.v1.Quote}
 */
proto.acompanha.quotes.v1.UnarchiveQuoteResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.quotes.v1.Quote} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.quotes.v1.Quote, 1));
};


/**
 * @param {?proto.acompanha.quotes.v1.Quote|undefined} value
 * @return {!proto.acompanha.quotes.v1.UnarchiveQuoteResponse} returns this
*/
proto.acompanha.quotes.v1.UnarchiveQuoteResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.UnarchiveQuoteResponse} returns this
 */
proto.acompanha.quotes.v1.UnarchiveQuoteResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.UnarchiveQuoteResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
shippingOptionIndex: jspb.Message.getFieldWithDefault(msg, 2, 0),
salesChannel: (f = msg.getSalesChannel()) && acompanha_common_v1_common_pb.SalesChannelRef.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest;
  return proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setShippingOptionIndex(value);
      break;
    case 3:
      var value = new acompanha_common_v1_common_pb.SalesChannelRef;
      reader.readMessage(value,acompanha_common_v1_common_pb.SalesChannelRef.deserializeBinaryFromReader);
      msg.setSalesChannel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShippingOptionIndex();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSalesChannel();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      acompanha_common_v1_common_pb.SalesChannelRef.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest} returns this
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 shipping_option_index = 2;
 * @return {number}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.prototype.getShippingOptionIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest} returns this
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.prototype.setShippingOptionIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional acompanha.common.v1.SalesChannelRef sales_channel = 3;
 * @return {?proto.acompanha.common.v1.SalesChannelRef}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.prototype.getSalesChannel = function() {
  return /** @type{?proto.acompanha.common.v1.SalesChannelRef} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.SalesChannelRef, 3));
};


/**
 * @param {?proto.acompanha.common.v1.SalesChannelRef|undefined} value
 * @return {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest} returns this
*/
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.prototype.setSalesChannel = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest} returns this
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.prototype.clearSalesChannel = function() {
  return this.setSalesChannel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest.prototype.hasSalesChannel = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.quotes.v1.Quote.toObject(includeInstance, f),
checkoutUuid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse;
  return proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.quotes.v1.Quote;
      reader.readMessage(value,proto.acompanha.quotes.v1.Quote.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheckoutUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.quotes.v1.Quote.serializeBinaryToWriter
    );
  }
  f = message.getCheckoutUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Quote data = 1;
 * @return {?proto.acompanha.quotes.v1.Quote}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.quotes.v1.Quote} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.quotes.v1.Quote, 1));
};


/**
 * @param {?proto.acompanha.quotes.v1.Quote|undefined} value
 * @return {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse} returns this
*/
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse} returns this
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string checkout_uuid = 2;
 * @return {string}
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.prototype.getCheckoutUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse} returns this
 */
proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.prototype.setCheckoutUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.acompanha.quotes.v1);
